import { DonutChart, type DonutSlice } from '@/components/charts/DonutChart'
import type { Bolletta } from '@/lib/graphql/types'
import { COLORS_PIE, EURO, VOCI_BOLLETTA } from '../constants'

/**
 * Donut chart "Distribuzione voci" — riprende le sole voci A..H positive.
 * Replica `PieChartReduced` del mobile (size 220, innerRatio 0.58).
 */
export function VociDonut({ invoice }: { invoice: Bolletta }) {
  const labels: Array<keyof Bolletta> = ['A', 'B', 'C', 'D', 'E', 'G', 'H']
  const data: DonutSlice[] = []
  let total = 0

  for (const l of labels) {
    const v = invoice[l]
    if (typeof v === 'number' && v > 0) {
      const value = Number(v.toFixed(2))
      data.push({
        label: VOCI_BOLLETTA[l as string] ?? (l as string),
        value,
        color: COLORS_PIE[l as string] ?? 'hsl(var(--primary))',
      })
      total += value
    }
  }

  if (data.length === 0) return null

  return (
    <section className="flex flex-col items-center gap-3">
      <p className="self-start text-xs uppercase tracking-wider text-muted-foreground">
        Distribuzione voci
      </p>
      <DonutChart
        data={data}
        size={220}
        innerRatio={0.58}
        centerLabel="Totale"
        centerValue={`${total.toFixed(2).replace('.', ',')} ${EURO}`}
        unit={EURO}
      />
    </section>
  )
}
